module.exports = __webpack_public_path__ + "img/top_banner.2df5f503.png";